"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.couponRules = exports.commonData = void 0;
exports.init = init;
exports.timeFormat = void 0;
var _vue = _interopRequireDefault(require("vue"));
var _componentsApi = require("@/api/componentsApi");
var _api = require("./api");
var _store = require("@/api/store");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var couponRules = exports.couponRules = {
  // name: [
  //   { required: true, message: '请输入优惠券名称', trigger: 'blur' },
  //   // { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
  // ],
  applicableRangeType: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  couponDiscount: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  couponType: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  distributionCustomers: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  endTime: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  isPublic: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  limitType: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  name: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  internalRemark: [],
  startTime: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  totalQuantity: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  validityEnd: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  validityStart: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  receiveTime: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  lifespanTime: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  validityType: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  maxDiscount: [{
    required: true,
    message: '必填',
    trigger: 'blur'
  }],
  packageIds: [{
    type: 'array'
  }]
};
var timeFormat = exports.timeFormat = 'yyyy-MM-dd HH:mm:ss';
var commonData = exports.commonData = _vue.default.observable({
  distributionCustomers: [],
  discountMethodsEnum: [],
  requisitionRulesEnum: [],
  showCateIdOption: []
});

//适用分销客户
function getDistributionCustomers(_x) {
  return _getDistributionCustomers.apply(this, arguments);
} // 优惠方式枚举值列表
function _getDistributionCustomers() {
  _getDistributionCustomers = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
    var _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return (0, _api.getCustomersApi)(params);
        case 1:
          _t = _context.v;
          if (_t) {
            _context.n = 2;
            break;
          }
          _t = [];
        case 2:
          commonData.distributionCustomers = _t;
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _getDistributionCustomers.apply(this, arguments);
}
function getDiscountMethodsEnum(_x2) {
  return _getDiscountMethodsEnum.apply(this, arguments);
} //  领用规则枚举值列表
function _getDiscountMethodsEnum() {
  _getDiscountMethodsEnum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
    var res, _t2;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _context2.n = 1;
          return (0, _componentsApi.dictionaryGetListApi)(params);
        case 1:
          _t2 = _context2.v;
          if (_t2) {
            _context2.n = 2;
            break;
          }
          _t2 = [];
        case 2:
          res = _t2;
          commonData.discountMethodsEnum = res && res.map(function (j) {
            return _objectSpread(_objectSpread({}, j), {}, {
              id: Number(j.id)
            });
          }) || [];
        case 3:
          return _context2.a(2);
      }
    }, _callee2);
  }));
  return _getDiscountMethodsEnum.apply(this, arguments);
}
function getRequisitionRulesEnum(_x3) {
  return _getRequisitionRulesEnum.apply(this, arguments);
}
/**
 *  获取分类
 * @param {*} type  1：商品分类 8：展示分类
 */
function _getRequisitionRulesEnum() {
  _getRequisitionRulesEnum = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(params) {
    var res, _t3;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          _context3.n = 1;
          return (0, _componentsApi.dictionaryGetListApi)(params);
        case 1:
          _t3 = _context3.v;
          if (_t3) {
            _context3.n = 2;
            break;
          }
          _t3 = [];
        case 2:
          res = _t3;
          commonData.requisitionRulesEnum = res && res.map(function (j) {
            return _objectSpread(_objectSpread({}, j), {}, {
              id: Number(j.id)
            });
          }) || [];
        case 3:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return _getRequisitionRulesEnum.apply(this, arguments);
}
function getCategorySelect(type) {
  (0, _store.categoryApi)({
    status: -1,
    type: type
  }).then(function (res) {
    commonData.showCateIdOption = addDisabled(res);
  });
}
/**
 * 限制商品分类只能选择开启的
 */
function addDisabled() {
  var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var list = [];
  try {
    arr.forEach(function (e, index) {
      var e_new = _objectSpread(_objectSpread({}, e), {}, {
        disabled: !e.status
      });
      if (e.child) {
        var childList = addDisabled(e.child);
        e_new = _objectSpread(_objectSpread({}, e_new), {}, {
          child: childList
        });
      }
      list.push(e_new);
    });
  } catch (error) {
    console.log("\u5904\u7406\u5206\u7C7B\u4FE1\u606F\u51FA\u73B0\u9519\u8BEF\uFF01----".concat(error));
  }
  return list;
}
function init() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.merchantMode) {
    getDistributionCustomers({
      types: 3
    });
    getCategorySelect(1); // 获取展示分类
  }
  getDiscountMethodsEnum({
    group: 'Coupon_Type'
  });
  getRequisitionRulesEnum({
    group: 'Limit_Type'
  });
}